import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
// import { CUSTOMER_V1_REFERENCE_CUSTOMER_DETAILS } from "../../../../common/CustomerConstants";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
// import LogisticsConstants from "../../../../common/LogisticsConstants";
import Constants from "../../../../common/SupplierConstants";
// import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import logistics from "../../../../services/logistics_appCommonService";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
// import { getTransportList } from "../../../../redux/feature/logistics_app/logisticsSlice";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { getTodaysData } from "../../../../common/Validations";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import LogisticsConstants from "../../../../common/LogisticsConstants";
import { useNavigate } from "react-router-dom";
// import { validateRequired } from "../../../../common/Validations";

const LogisticFuelEntryModal = React.forwardRef((props, ref) => {
  // eslint-disable-next-line
  const message = {
    VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
    VALID_MAIL_ID: "Please enter a valid email address.",
    VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
    VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
    VALID_ALTERNATE_CONTACT_NUMBER:
      "Please enter a valid alternate contact number.",
    VALID_PURPOSE_JUSTIFICATION:
      "Please ensure the justification is under 500 characters.",
    VALID_POSTAL_CODE:
      "Enter a 6-character postal code with uppercase letters and numbers only",
    VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
    VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
    EXIStS_MAIL_ID: "Email already exists",
    EXIStS_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
    FILL_REQUIRED_FIELD: "Please fill the required field",
    ALTERNATE_MAIL_ID: "Email ID is same",
    ALTERNATE_CONTACT_NUMBER: "Contact number is same",
    GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
  };
   // eslint-disable-next-line 
  const dispatch = useDispatch();
  const navigate = useNavigate()

  let userData = useSelector((state) => state?.user?.data);
  const userId = userData?.userId || null;

  let POLineItemInitialData = [
    {
      local_id: 1,
      materialCode: "",
      materialDescription: "",
      materialGroup: "",
      purchaseQuantity: "",
      orderUnitOfMeasure: "",
      itemValue: "",
      orderPriceUnit: "",
      deliveryDate: "",
      plant: "",
      storageLocn: "",
    },
  ];

  const [formInputs, setFormInputs] = useState({
    transportRequestDate: getTodaysData(),
    previousTripCharges: "",
    previousTripChargesCode: "",
    previousTripChargesDesc: "",
    previousTripChargesAmount: "",
    billNumber: "",
    billDate: "",
  });

  const [getDeliveryAckStatusporps, setDeliveryAckStatusporps] = useState();
  const onSuccessUploadDocumentType = (local_id, data) => {
    setPOLineItemsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id
          ? { ...row, [data.fieldName]: data.attachmentId }
          : row
      )
    );
  };
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const priviousTripChargesData = [
    { id: 1, name: "Yes", code: "YES", description: "Yes" },
    { id: 2, name: "No", code: "NO", description: "No" },
  ];

  let SchedulePOLineItemInitialCol = [
    {
      name: "Srl Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "100px",
    },

    {
      name: "Material",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <div className="d-flex flex-column">
          <span>{row.materialCode}</span>
          <span>{row.materialDescription}</span>
          <span>{row.materialGroup}</span>
        </div>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Qty",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <div className="d-flex column">
          <span className="fw-medium px-2">{row.purchaseQuantity}</span>
          <span className="fw-medium">{row.orderUnitOfMeasure}</span>
        </div>
      ),
      sortable: true,
      width: "100px",
    },

    {
      name: "Recived Qty",
      // selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="recivedQty"
          type="number"
          placeholder=""
          value={row.recivedQty || ""}
          onChange={(event) => handleInputChange1(row.local_id, event)}
          disabled={getEditmode}
        />
      ),
      width: "140px",
    },
    {
      name: "Shortage Qty (MT)",
      // selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="shortageQty"
          type="number"
          placeholder=""
          value={row.shortageQty || ""}
          onChange={(event) => handleInputChange1(row.local_id, event)}
          disabled={getEditmode}
        />
      ),
      width: "160px",
    },

    {
      name: "Shortage Qty By Bags",
      // selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="shortageQtyByBags"
          placeholder=""
          value={row.shortageQtyByBags || ""}
          disabled={getEditmode}
        />
      ),
      width: "180px",
    },
    {
      name: "Upload Invoice",
      cell: (row) => (
        <FileUploadComponent
          id={`invoiceFileAttachment_${row.local_id}`}
          name="invoiceFileAttachment"
          label=""
          allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
          multiple={false}
          required={true}
          onSuccessUpload={(data) =>
            onSuccessUploadDocumentType(row.local_id, data)
          }
          value={row.invoiceFileAttachment || ""}
        />
      ),
      width: "220px",
    },
    {
      name: "Attachments",
      selector: (row) => row.invoiceFileAttachment,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          {row.invoiceFileAttachment && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row.invoiceFileAttachment)}
            />
          )}
        </div>
      ),
      sortable: true,
      width: "130px",
    },
  ];

  const [getPOLineItemsData, setPOLineItemsData] = useState(
    POLineItemInitialData
  );

  const [isCardVisible4, setCardVisible4] = useState(true);

  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };

  // const [gettransportRequest, settransportRequest] = useState({
  //   transportrequestDetails: {
  //     transportRequestDate: getTodaysData(),
  //     department: "",
  //     transportGroup: "",
  //     purchaseOrderNr: "",
  //     licenseNr: "",
  //     issuingDate: "",
  //     expiryDate: "",
  //     driverName1: "",
  //     vehicleNr: "",
  //   },
  // });

  const [getDropdownData, setDropdownData] = useState([]);
  const [getEditmode, setEditMode] = useState(true);

  const [isCardVisible3, setCardVisible3] = useState(true);

  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const handleInputChange1 = (local_id, event, fieldName) => {
    const { value, name } = event.target;

    setPOLineItemsData((prevRows) =>
      prevRows.map((row) => {
        if (row.local_id === local_id) {
          const updatedRow = { ...row };

          const key = fieldName || name;
          updatedRow[key] = value;

          const purchaseQuantity = parseFloat(updatedRow.purchaseQuantity) || 0;
          let recivedQty = parseFloat(updatedRow.recivedQty) || 0;

          // -----------------------------------------
          // 🚫 Block: recivedQty > purchaseQuantity
          // -----------------------------------------
          if (key === "recivedQty" && recivedQty > purchaseQuantity) {
            recivedQty = purchaseQuantity;
            updatedRow.recivedQty = purchaseQuantity;
          }

          // -----------------------------------------
          // ✔ Calculate shortageQty
          // -----------------------------------------
          const shortageQty = purchaseQuantity - recivedQty;
          updatedRow.shortageQty = shortageQty;

          // -----------------------------------------
          // ✔ Calculate shortageQtyByBags
          // -----------------------------------------
          updatedRow.shortageQtyByBags = shortageQty * 20;

          // -----------------------------------------
          // ✔ Calculate itemValue = Qty × UnitPrice
          // (keeping this if still required)
          // -----------------------------------------
          updatedRow.itemValue = (
            purchaseQuantity * (parseFloat(updatedRow.orderPriceUnit) || 0)
          ).toFixed(2);

          return updatedRow;
        }
        return row;
      })
    );
  };

  useEffect(() => {
    if (!getDropdownData) return;
    if (!getDropdownData.code || !getDropdownData.name) {
      return;
    }
    // Only update when it's specifically the previousTripCharges dropdown
    if (getDropdownData?.textField === "previousTripCharges") {
      setFormInputs((prevFormInputs) => ({
        ...prevFormInputs,
        previousTripCharges: getDropdownData?.name || "",
        previousTripChargesCode: getDropdownData?.code || "",
        previousTripChargesDesc: getDropdownData?.description || "",
      }));
    }
    // Don't handle other dropdowns here - let them update elsewhere
  }, [getDropdownData]);
  // eslint-disable-next-line
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formaInputs) => ({
      ...formaInputs,
      [name]: value,
    }));
  };

  /* cancel */
  const handleCancel = () => {
    props.onHide();
    setFormInputs({
      loadingCharges: "",
      rtoCharges: "",
      unloadingCharges: "",
      totalHandlingCharges: "",
    });
  };

  /* handle Update */
  const handleUpdate = async () => {
    const obj = {
      ...formInputs,
      // gettransportRequest: gettransportRequest,
      items: getPOLineItemsData,
      deliveryStatus: "DELIVERD",
      // cumulativeDeliveryValue: cumulativeDeliveryValue,
      // unloadingCharges: cumulativeDeliveryValue,
      // totalHandlingCharges: totalHandlingCharges,
      // Handling:otherChargesTotal,
      acceptedUserID: userId,
      deliveryAckStatus: "Acknowledged",
      deliveryAckStatusCode: "Acknowledged",
      deliveryAckStatusDesc: "Acknowledged",
    };

    console.log("obj", obj);
    await logistics.updateLogisticsTransport(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });

        // let obj = {
        //   queryName: "getLogisticsTransportListACK",
        //   module: "",
        //   page: 1,
        //   per_page: 10,
        // };
        // dispatch(getTransportList(obj));
        props.onHide();
        navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_LIST_ACK);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  //load initial data
  useEffect(() => {
    if (props?.data) {
      const deliveryAckStatus = props?.data?.deliveryAckStatus;
      let tripChargesConfig = {
        previousTripCharges: "No",
        previousTripChargesCode: "NO",
        previousTripChargesDesc: "No",
        previousTripChargesAmount: "",
        billNumber: "",
        billDate: "",
        previousTripRemarks:""
      };
      switch (deliveryAckStatus) {
        case "Acknowledged":
          tripChargesConfig = {
            previousTripCharges: props?.data?.previousTripCharges ?? "",
            previousTripChargesCode: props?.data?.previousTripChargesCode ?? "",
            previousTripChargesDesc: props?.data?.previousTripChargesDesc ?? "",
            previousTripChargesAmount:
              props?.data?.previousTripChargesAmount ?? "",
            billNumber: props?.data?.billNumber ?? "",
            billDate: props?.data?.billDate ?? "",
            previousTripRemarks: props?.data?.previousTripRemarks ?? "",
          };
          break;
        case "In Transit":
          // Already defaults to "No" values from initial config
          break;
        default:
          // For any other status, keep the "No" defaults
          break;
      }
      // console.log(">>tripChargesConfig", tripChargesConfig);
      setFormInputs({
        ...props.data,
        ...tripChargesConfig,
        transportRequestDate: getTodaysData(),
      });
    }
    setPOLineItemsData(props?.data?.items);

    setDeliveryAckStatusporps(props?.data?.deliveryAckStatus);
    // settransportRequest(props?.data?.transportrequestDetails);

    setEditMode(props?.data?.deliveryStatus === "DELIVERD" ? true : false);

    setDeliveryAckStatusporps(props?.data?.deliveryAckStatus);

    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
    // eslint-disable-next-line
  }, [props]);

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Delivery Acknowledgement
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* header data */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} className="text-center logoBtn">
                  <span className="iconLogo">BD</span>
                </Col>
                <Col xs={8}>
                  <span className="headerTitle">Basic Details</span>
                  <span className="subHeaderTitle">Basic Details</span>
                </Col>
                <Col xs={2}>
                  <div className="d-flex justify-content-end p-2 me-3"></div>
                </Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible3 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Transport request Date"
                      type="date"
                      name="transportRequestDate"
                      placeholder=""
                      value={formInputs.transportRequestDate}
                      // onChange={transportrequestInputchange}
                      // required={true}
                      disabled={true}
                    />
                  </Col>
                  {/*  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Company Name"
                      name="department"
                      placeholder=""
                      value={
                        gettransportRequest?.department ||
                        formInputs?.department ||
                        formInputs?.companyCode
                      }
                      onChange={transportrequestInputchange}
                      // required={true}
                      disabled={true}
                    />
                  </Col> */}

                  {/* )} */}

                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Vehicle Nr"
                      name="vehicleNr"
                      placeholder=""
                      value={formInputs?.vehicleNr}
                      // onChange={transportrequestInputchange}
                      // required={true}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <ComboboxField
                      label="Driver Name"
                      placeholder=""
                      // data={getDriverNames}
                      id="driverName1"
                      iconClassName="dropdownIcon"
                      name="driverName1"
                      code="driverName1"
                      description="driverName1Desc"
                      setValue={formInputs?.driverName1 || ""}
                      // getvalue={setDropdownData}
                      // required={true}
                      disabled={true}
                      // error={validation.driverName1}
                    />
                  </Col>
                  {/*  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      type="number"
                      label="Driver Trip Amount"
                      id="driverTripAmount"
                      name="driverTripAmount"
                      placeholder=""
                      value={formInputs?.driverTripAmount || ""}
                      onChange={onInputChange}
                      // required={true}
                      disabled={getEditmode}
                    />
                  </Col> */}
                  {/*   {!getEditmode && (
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="commTopButtonRightLeftPadding"
                    >
                      <ComboboxField
                        label="Acceptence"
                        placeholder=""
                        data={getDeliveryAckStatus}
                        id="deliveryAckStatus"
                        iconClassName="dropdownIcon"
                        name="deliveryAckStatus"
                        code="deliveryAckStatusCode"
                        description="deliveryAckStatusDesc"
                        setValue={formInputs?.deliveryAckStatus || ""}
                        getvalue={setDropdownData}
                        // required={true}
                        disabled={getEditmode}
                        error={validation.driverName1}
                      />
                    </Col>
                  )} */}
                  {getEditmode && (
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Vehicle Nr"
                        name="vehicleNr"
                        placeholder=""
                        value={getDeliveryAckStatusporps}
                        disabled={true}
                      />
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* Price Shedule / Line Item */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible4 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility4}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>
                <Col xs={4} md={8} lg={4}>
                  <span className="headerTitle">Item Details</span>
                  <span className="subHeaderTitle">
                    Price Shedule / Line Item
                  </span>
                </Col>
                <Col xs={12} md={8} lg={8} className="headerButtonAlign"></Col>
              </Row>
            </h2>
            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible4 ? "visible" : ""
              }`}
              // aria-labelledby="headingOne"
              // data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                {" "}
                {/* dynamicDropdown */}
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      title=""
                      columns={SchedulePOLineItemInitialCol}
                      data={getPOLineItemsData}
                      paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                      pagination
                      // selectableRows
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* Expence */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} className="text-center logoBtn">
                  <span className="iconLogo">EC</span>
                </Col>
                <Col xs={8}>
                  <span className="headerTitle">Expense charges</span>
                  <span className="subHeaderTitle">Expense charges</span>
                </Col>
                <Col xs={2}>
                  <div className="d-flex justify-content-end p-2 me-3"></div>
                </Col>
              </Row>
            </h2>
            <div
              className={`accordion-collapse collapse show ${
                isCardVisible3 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <ComboboxField
                      label="Expense Trip Charges"
                      data={priviousTripChargesData}
                      id="previousTripCharges"
                      iconClassName="dropdownIcon"
                      name="previousTripCharges"
                      code="previousTripChargesCode"
                      description="previousTripChargesDesc"
                      required={true}
                      getvalue={setDropdownData}
                      setValue={formInputs?.previousTripCharges || ""} // ← This is a STRING!
                      disabled={getEditmode}
                    />
                  </Col>
                  {formInputs?.previousTripChargesCode === "YES" && (
                    <>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="expense Trip Charges Amount"
                          name="previousTripChargesAmount"
                          type="number"
                          placeholder=""
                          value={formInputs?.previousTripChargesAmount}
                          onChange={onInputChange}
                          disabled={getEditmode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Bill Number"
                          name="billNumber"
                          placeholder=""
                          value={formInputs?.billNumber}
                          onChange={onInputChange}
                          disabled={getEditmode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          label="Bill Date"
                          name="billDate"
                          placeholder=""
                          value={formInputs?.billDate}
                          onChange={onInputChange}
                          disabled={getEditmode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Trip Expense Remarks"
                          placeholder=""
                          name="previousTripRemarks"
                          id="previousTripRemarks"
                          value={formInputs?.previousTripRemarks || ""}
                          onChange={onInputChange}
                          disabled={getEditmode}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/* header data */}
        {!getEditmode && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end mt-2"
            >
              <button className="btnTable btn-danger" onClick={handleCancel}>
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end mt-2">
              <button
                className="btnTable"
                onClick={handleUpdate}
                // disabled={disable}
              >
                Acknowledge
              </button>
            </Col>
          </Row>
        )}
      </Modal.Body>

      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </Modal>
  );
});

export default LogisticFuelEntryModal;
